<template>
  <van-popup
    class="order-success-dialog"
    :value="show"
    :close-on-click-overlay="false"
    @input="onUpdateShow"
  >
    <div class="dialog-content">
      <!-- 头部 -->
      <div class="dialog-header">
        <div class="header-left"></div>
        <div class="header-title">
          <div class="title-text">下单成功</div>
        </div>
        <div class="header-right">
          <div class="close-btn" @click="handleClose">
            <img src="@/assets/icons/closer.svg" alt="" />
          </div>
        </div>
      </div>
      
      <!-- 内容区域 -->
      <div class="content-area">
        <div class="info-list">
          <!-- 快递公司 -->
          <div class="info-row">
            <div class="info-label">快递公司</div>
            <div class="info-value">顺丰同城</div>
          </div>
          <!-- 快递单号 -->
          <div class="info-row">
            <div class="info-label">快递单号</div>
            <div class="info-value">SF1928272371738</div>
          </div>
          <!-- 预估费用 -->
          <div class="info-row">
            <div class="info-label">预估费用</div>
            <div class="info-value">￥40</div>
          </div>
        </div>
      </div>
      
      <!-- 按钮区域 -->
      <div class="dialog-buttons">
        <van-button class="btn-primary" type="primary" @click="handleConfirm">
          确定
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'OrderSuccessDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onUpdateShow(value) {
      this.$emit('update:show', value)
    },
    handleClose() {
      this.$emit('update:show', false)
      this.$emit('close')
    },
    handleConfirm() {
      this.$emit('confirm')
      this.handleClose()
    }
  }
}
</script>

<style lang="less" scoped>
.order-success-dialog {
  width: 320/20rem;
  background: #FFFFFF;
  border-radius: 10/20rem;
  overflow: hidden;
  
  .dialog-content {
    padding: 0;
  }
}

.dialog-header {
  display: flex;
  align-items: center;
  padding: 10/20rem 10/20rem 6/20rem;
  height: 38/20rem;
  
  .header-left {
    width: 22/20rem;
  }
  
  .header-title {
    flex: 1;
    height: 22/20rem;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .title-text {
      font-family: 'PingFang SC', sans-serif;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.25;
      color: #000000;
      text-align: center;
    }
  }
  
  .header-right {
    width: 22/20rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .close-btn {
    width: 22/20rem;
    height: 22/20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    
    img {
      width: 100%;
      height: 100%;
    }
    
    &:hover {
      opacity: 0.7;
    }
  }
}

.content-area {
  padding: 0 20/20rem;
  
  .info-list {
    .info-row {
      display: flex;
      align-items: center;
      padding: 8/20rem 0;
      height: 46/20rem;
      border-bottom: 1px solid #E4E4E4;
      
      &:last-child {
        border-bottom: none;
      }
      
      .info-label {
        flex: 1;
        font-family: 'PingFang SC', sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.286;
        color: #000000;
        text-align: left;
      }
      
      .info-value {
        flex: 1;
        font-family: 'PingFang SC', sans-serif;
        font-size: 12px;
        font-weight: 400;
        line-height: 1.4;
        color: #7D7D7D;
        text-align: right;
      }
    }
  }
}

.dialog-buttons {
  display: flex;
  gap: 12/20rem;
  padding: 16/20rem 20/20rem 20/20rem;
  
  .btn-primary {
    flex: 1;
    height: 38/20rem;
    border-radius: 4/20rem;
    font-family: 'SF Pro', 'PingFang SC', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.714;
    background: #000000;
    color: #FFFFFF;
    
    &:hover {
      opacity: 0.8;
    }
    
    &:active {
      opacity: 0.6;
    }
  }
}
</style> 